// Based on https://codepen.io/aaronbarker/pen/MeaRmL

const originalCSS = {}
let foundCSS = 0

const findCSS = function () {
  const toBeFetched = []
  $('style, link[rel=stylesheet]').filter(':not([data-css-handled])').each(function (i, el) {
    let theCSS
    i = foundCSS
    foundCSS += 1
    const $el = $(el)
    const isPrint = $el.attr('media') === 'print'

    $el.attr('data-css-handled', true)

    if ($el.is('style')) {
      if (isPrint) {
        theCSS = `@media print {${$el.get(0).innerHTML}}`
      } else {
        theCSS = $el.get(0).innerHTML
      }
    } else {
      theCSS = ''
      const ajax = $.ajax({
        url: $el.attr('href'),
        dataType: 'text'
      }).then(function (response) {
        if (isPrint) {
          originalCSS[i] = `@media print {${response}}`
        } else {
          originalCSS[i] = response
        }
      })

      toBeFetched.push(ajax)
    }

    originalCSS[i] = theCSS
  })

  return $.when.apply($, toBeFetched)
}

const updateCSS = customStyles =>
  (() => {
    const result = []
    for (const id in originalCSS) {
      const oldCSS = originalCSS[id]
      const newCSS = replaceGetters(oldCSS, customStyles)
      const existing = document.querySelector(`#css-handled${id}`)
      if (existing) {
        result.push(existing.innerHTML = newCSS)
      } else {
        const style = document.createElement('style')
        style.type = 'text/css'
        style.innerHTML = newCSS
        style.setAttribute('data-css-handled', true)
        style.setAttribute('custom-user-style', true)
        style.id = `css-handled${id}`
        result.push(document.getElementsByTagName('head')[0].appendChild(style))
      }
    }
    return result
  })()

var replaceGetters = function (curCSS, customStyles) {
  for (const variable in customStyles) {
    // Replace defined variables
    const value = customStyles[variable]
    const getterRegex = new RegExp(`var\\(\\s*--pollev-${variable}\\s*\\)`, 'g')
    curCSS = curCSS.replace(getterRegex, value)
  }

  return curCSS
}

export const applyTheme = function (theme, themeRootElement = document.documentElement) {
  if (typeof theme === 'string') { theme = JSON.parse(theme) }
  if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
    for (const variable in theme) {
      themeRootElement.style.setProperty(`--pollev-${variable}`, theme[variable])
    }
  } else {
    findCSS().then(() => updateCSS(theme))
  }
  const headerBg = theme['header-background']
  if (typeof headerBg === 'string' && /^#[0-9a-f]{6}$/i.test(headerBg)) {
    $('meta[name=theme-color]').attr('content', theme['header-background'])
  }
}

export const addCSS = function (url) {
  const $style = $('<link/>').attr({
    'custom-user-style': '',
    rel: 'stylesheet',
    href: url,
    type: 'text/css'
  })

  return $('head').append($style)
}

export const addJS = function (url) {
  const $script = $('<script/>').attr({
    'custom-user-style': '',
    src: url,
    type: 'text/javascript'
  })

  return $('body').append($script)
}
